export default "__VITE_ASSET__Bu6X$DNw__"